module.exports = __webpack_public_path__ + "img/intro_sub_no.51b0cbf1.svg";